(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      try {
        this.searchModal.close(false);
      } catch {
        // do nothing
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-rsc-product-description-sc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Desktop/Tablet tabs
    document.querySelectorAll('[data-mh-rsc-pd-tabs]').forEach(function (root) {
      const tabButtons = Array.from(root.querySelectorAll('.mh-rsc-product-description__tab-btn[data-tab]'));
      const panels = Array.from(root.querySelectorAll('.mh-rsc-product-description__panel-inner[data-panel]'));

      if (panels.length) {
        function setActive(key) {
          tabButtons.forEach(btn => btn.setAttribute('aria-selected', btn.dataset.tab === key ? 'true' : 'false'));
          panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === key));
        }

        const firstPanel = panels[0];
        if (firstPanel) setActive(firstPanel.dataset.panel);

        tabButtons.forEach(btn => btn.addEventListener('click', () => setActive(btn.dataset.tab)));
      }

      // Mobile accordions: keep only one open at a time
      const accWrap = root.querySelector('[data-mh-rsc-accordion]');
      if (accWrap) {
        const items = Array.from(accWrap.querySelectorAll('details.mh-rsc-product-description__acc'));
        items.forEach((d) => {
          d.addEventListener('toggle', () => {
            if (!d.open) return;
            items.forEach((other) => {
              if (other !== d) other.open = false;
            });
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-rsc-text-media-sc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function mhRscTextMediaInit(scope) {
      scope.querySelectorAll('[data-mh-rsc-text-media-video]').forEach(function (wrap) {
        // ✅ prevent duplicate init (very common in theme editor / section reloads)
        if (wrap.dataset.mhRscTextMediaInit === 'true') return;
        wrap.dataset.mhRscTextMediaInit = 'true';

        var frame = wrap.querySelector('[data-video-frame]');
        var btn = wrap.querySelector('[data-mh-rsc-text-media-video-btn]');
        if (!frame || !btn) return;

        var video = frame.querySelector('video');
        if (!video) return;

        // iOS inline hints
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.playsInline = true;

        var iconPlay = btn.querySelector('[data-mh-rsc-text-media-icon-play]');
        var iconPause = btn.querySelector('[data-mh-rsc-text-media-icon-pause]');

        function mhRscTextMediaSetUI(isPlaying) {
          wrap.dataset.mhRscTextMediaPlaying = isPlaying ? 'true' : 'false';

          if (isPlaying) {
            btn.setAttribute('aria-label', 'Pause video');
            if (iconPlay) iconPlay.classList.add('is-hidden');
            if (iconPause) iconPause.classList.remove('is-hidden');
            btn.classList.remove('is-faded');
          } else {
            btn.setAttribute('aria-label', 'Play video');
            if (iconPlay) iconPlay.classList.remove('is-hidden');
            if (iconPause) iconPause.classList.add('is-hidden');
            btn.classList.remove('is-faded');
          }
        }

        mhRscTextMediaSetUI(false);

        function mhRscPlaySafely() {
          // optimistic UI
          mhRscTextMediaSetUI(true);

          // if not ready, load then play on canplay
          if (video.readyState < 2) {
            try { video.load(); } catch (e) {}
            var onCanPlay = function () {
              video.removeEventListener('canplay', onCanPlay);
              mhRscPlaySafely(); // retry once ready
            };
            video.addEventListener('canplay', onCanPlay, { once: true });
            return;
          }

          // attempt play with strong error handling
          try {
            var p1 = video.play();
            if (p1 && typeof p1.catch === 'function') {
              p1.catch(function () {
                // fallback: muted play is most reliable cross-browser
                video.muted = true;
                video.setAttribute('muted', '');
                try {
                  var p2 = video.play();
                  if (p2 && typeof p2.catch === 'function') {
                    p2.catch(function () {
                      mhRscTextMediaSetUI(false);
                    });
                  }
                } catch (e2) {
                  mhRscTextMediaSetUI(false);
                }
              });
            }
          } catch (e) {
            // synchronous throw case
            video.muted = true;
            video.setAttribute('muted', '');
            try {
              var p3 = video.play();
              if (p3 && typeof p3.catch === 'function') {
                p3.catch(function () {
                  mhRscTextMediaSetUI(false);
                });
              }
            } catch (e3) {
              mhRscTextMediaSetUI(false);
            }
          }
        }

        function mhRscToggle() {
          if (video.paused) mhRscPlaySafely();
          else {
            video.pause();
            mhRscTextMediaSetUI(false);
          }
        }

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          mhRscToggle();
        });

        // optional: allow clicking video too
        video.addEventListener('click', function (e) {
          e.preventDefault();
          mhRscToggle();
        });

        // keep UI synced
        video.addEventListener('play', function () { mhRscTextMediaSetUI(true); });
        video.addEventListener('pause', function () { mhRscTextMediaSetUI(false); });
        video.addEventListener('ended', function () { mhRscTextMediaSetUI(false); });

        // hover behavior only when playing
        wrap.addEventListener('mouseenter', function () {
          if (wrap.dataset.mhRscTextMediaPlaying === 'true') btn.classList.remove('is-faded');
        });
        wrap.addEventListener('mouseleave', function () {
          if (wrap.dataset.mhRscTextMediaPlaying === 'true') btn.classList.add('is-faded');
        });
      });
    }

    mhRscTextMediaInit(document);
    document.addEventListener('shopify:section:load', function (e) {
      mhRscTextMediaInit(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
